<template>
    <div class="p-4 bg-gray-50 border border-gray-200 rounded-xl">
        <ui-form-section class="mb-4">
            <ui-input label="Mileage / Hours" name="mileage" :error="form.errors.get('mileage')" v-model="form.mileage"></ui-input>
        </ui-form-section>
        <div class="flex justify-end space-x-4">
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">Submit New Mileage</ui-button-new>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vehicle: Object,
    },
    data () {
        return {
            form: new Form({}, async (form) => {
                await this.vehicle.updateMileage(form.export())
            }),
        }
    },
}
</script>
